import { socket } from "../index";

const emitDestroyRoom = () => {
  socket?.emit('DESTROY_ROOM');
}

export default emitDestroyRoom;